import { useEffect, useState } from "react";

/**
 * Has `waiting` held for `ms`? A single wait for something only a page can say (that it has drawn), so it
 * asks nothing and repeats nothing. It counts again from zero when `again` changes (another preview), and it
 * is false the moment `waiting` stops.
 */
export function useStillWaiting(waiting: boolean, ms: number, again: unknown = null): boolean {
  const [late, setLate] = useState(false);
  useEffect(() => {
    setLate(false);
    if (!waiting) return undefined;
    const timer = window.setTimeout(() => setLate(true), ms);
    return () => window.clearTimeout(timer);
  }, [waiting, ms, again]);
  return late && waiting;
}
